// CartContext.js
import React, { createContext, useState, useContext, useEffect } from "react";

const CartContext = createContext();

export const useCart = () => {
    return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);

    // Cargar el carrito desde localStorage al iniciar
    useEffect(() => {
        const savedCartItems = JSON.parse(localStorage.getItem("cartItems"));
        if (savedCartItems) {
            setCartItems(savedCartItems);
        }
    }, []);

    // Actualizar localStorage cada vez que cartItems cambie
    useEffect(() => {
        if (cartItems.length > 0) {
            localStorage.setItem("cartItems", JSON.stringify(cartItems));
        }
    }, [cartItems]);

    // Agregar un producto al carrito
    const addItemToCart = (product) => {
        console.log("Producto recibido:", product);
        setCartItems((prevItems) => {
            const existingItem = prevItems.find(item => item.id === product.id);
            if (existingItem) {
                console.log("Producto ya existente, incrementando cantidad:", existingItem);
                return prevItems.map(item =>
                    item.id === product.id ? { ...item, quantity: item.quantity + product.quantity } : item
                );
            }
    
            console.log("Producto nuevo, añadiendo al carrito:", product);
            return [...prevItems, product];
        });
    };
    

    // Eliminar un producto del carrito
    const removeItemFromCart = (id) => {
        setCartItems((prevItems) => {
            const updatedCart = prevItems.filter(item => item.id !== id);
            // Guardamos el carrito actualizado en localStorage
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
            return updatedCart;
        });
    };

    // Cambiar la cantidad de un producto
    const updateItemQuantity = (id, newQuantity) => {
        setCartItems((prevItems) => {
            return prevItems.map((item) =>
                item.id === id
                    ? { ...item, quantity: Math.max(newQuantity, 1) } // Asegura que la cantidad mínima sea 1
                    : item
            );
        });
    };    

    // Vaciar el carrito
    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem("cartItems"); // Eliminar del localStorage cuando vacíes el carrito
    };

    // Función para obtener el total de productos en el carrito
    const getTotalItems = () => {
        return cartItems.reduce((total, item) => total + item.quantity, 0);
    };

    return (
        <CartContext.Provider value={{ cartItems, addItemToCart, removeItemFromCart, updateItemQuantity, clearCart, getTotalItems }}>
            {children}
        </CartContext.Provider>
    );
};
